import Head from "next/head";
import { ProfilePage } from "components/organisms/Profile";
export default function ProfilePageComponent() {
  return <>
            <Head data-sentry-element="Head" data-sentry-source-file="index.tsx">
                <title>CharGen: Profile Page - AI-Generated D&D Art</title>
                <meta property="og:url" key="og:url" content="https://char-gen.com/profile" data-sentry-element="meta" data-sentry-source-file="index.tsx" />
            </Head>
            <ProfilePage data-sentry-element="ProfilePage" data-sentry-source-file="index.tsx" />
        </>;
}